<template>
    <div>
        <div v-show="!loading" class="containerStyle">
            <!--帮助中心-->
            <div class="helpCenter">
                <el-header style="height: 100px">
                    <div class="top-bar">
                        <h2 class="title" @click="getKnowledge()" style="cursor: pointer">
                            知识分类
                        </h2>
                        <div class="search-bar">
                            <div class="search-wrapper">
                                <el-input
                                        class="search-core"
                                        placeholder="亲，您遇到什么问题"
                                        prefix-icon="el-icon-search"
                                        v-model="input2"
                                >
                                </el-input>
                                <el-button slot="append" class="search-btn" @click="getSearch(input2)">
                                    搜索
                                </el-button>
                            </div>

                        </div>
                        <div class="search-hot">
                            <a href="">注册激活</a>
                            <a href="">账号密码</a>
                            <a href="">班级作业</a>
                            <a href="">视频</a>
                            <a href="">评论</a>
                        </div>

                    </div>
                </el-header>
                <el-container style="margin-top: 50px">
                    <el-aside width="220px" >
                        <div class="menu-wrapper">
                            <el-menu
                                    router
                                    default-active="2"
                                    class="el-menu-vertical-demo"
                                    active-text-color="#4095cf"
                                    @open="handleOpen"
                                    @close="handleClose"
                            >
                                <el-submenu index="1" v-for="(item,index) in helpList" :key="index">
                                    <template slot="title">
                                        <span>{{item.categoryName}}</span>
                                    </template>
                                        <el-menu-item :index="'/login/studentAndTeacherPlatform/helpCenter/helpCenterList?id='+list.categoryId"
                                                      v-for="(list,index) in item.children" :key="index"
                                        >
                                          <div >
                                              • {{list.categoryName}}
                                          </div>
                                        </el-menu-item>
                                </el-submenu>
                            </el-menu>


                        </div>
                    </el-aside>

                    <el-main>
                        <router-view :key="key">

                        </router-view>

                    </el-main>
                </el-container>
            </div>

        </div>
        <loading :show="loading"></loading>
    </div>
</template>

<script>
    import{
        helpCategory,
        helpSearch,
    } from '../../config/index'
    import {setStore} from "../../assets/static/global/global";

    export default {
        name: "helpCenter",
        data(){
            return{
                input2:'',
                helpList:'',
                menuDisplay:false,
                loading:true,


            }
        },
            computed:{
                key(){
                    return this.$route.name?this.$route.name+ +new Date():this.$route+ +new Date();
                },
            },

        methods:{
            getKnowledge(){
                this.$router.push(
                    {path: '/login/studentAndTeacherPlatform/helpCenter/helpCenterIndex',

                    }
                )
            },
            handleOpen(key, keyPath) {
            },
            handleClose(key, keyPath) {
            },
            //获取帮助中心列表
            async getHelpCenter(){
                let res = await helpCategory();
                this.loading=true;
                if(res.status){
                    this.loading=false;
                    this.helpList = res.data;
                }else{
                    this.loading=false;
                }
            },
            async getHelpList(val){
                this.helpId = val;
               setStore('helpList',val);
                this.$router.push(
                    {path: '/login/studentAndTeacherPlatform/helpCenter/helpCenterList',
                        query:{id: val}
                    }
                )

            },
            async getSearch(val){
                this.$router.push(
                    {path: '/login/studentAndTeacherPlatform/helpCenter/helpSearch',
                        query:{id: val}
                    }
                    )
            },
            getMenu(){
                this.menuDisplay=!this.menuDisplay;
            }


        },
        created() {
            this.getHelpCenter();

        }
    }
</script>
<style lang="scss">
    .helpCenter{
    .el-input{
        border: none!important;
        border-radius: 21px !important;
        .el-input__inner{
            border-radius: 21px !important;
            border: 1px solid #0387ff;
        }
    }
        .is-opened{
            background: dodgerblue;

            .el-submenu__title{
                color: #fff;
            }
        }
        .el-menu-item{
            background: rgba(64,149,239,.15);
        }
        .el-tabs__item{
            padding: 0 35px;
            font-size: 16px;
        }
    }

</style>
<style scoped lang="scss">
    .helpCenter{
        //margin-top: 75px;
        .top-bar{
            position: relative;
            padding: 40px 0 0 240px;
            .title {
                position: absolute;
                top: 40px;
                left: 0;
                width: 220px;
                text-align: center;
                font-size: 30px;
                color: #4095ef;
            }
            .search-bar {
                position: relative;
                width: 510px;
                .search-wrapper{
                    height: 42px;
                    //border: 1px solid #4095ef;
                    //border-radius: 21px;
                    //padding-left: 50px;
                    .search-core {
                        display: block;
                        //width: 390px;
                        border: none;
                        font-size: 14px;
                        height: 39px;
                        line-height: 24px;
                        //padding: 9px;
                        background: transparent;
                    }
                    .search-btn {
                        position: absolute;
                        top: 1px;
                        right: 0;
                        width: 66px;
                        height: 40px;
                        border: none;
                        font-size: 16px;
                        color: #fff;
                        background-color: #0387ff;
                        background-image: -webkit-gradient(linear,right top,left top,from(#0387ff),to(#02aaff));
                        background-image: linear-gradient(-90deg,#0387ff,#02aaff);
                        border-radius: 36px;
                    }
                }
            }
            .search-hot{
                height: 57px;
                a {
                    display: inline-block;
                    margin: 10px 26px 26px;
                    color: #a7acb9;
                    font-size: 14px;
                }
            }
        }
        .menu-wrapper{
            width: 220px;
            .menu-list{
                .menu-title {
                    position: relative;
                    height: 50px;
                    line-height: 50px;
                    padding-left: 46px;
                    font-size: 14px;
                    color: #000;
                    cursor: pointer;
                    background: #f9fafc url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAAAAXNSR0IArs4c6QAAAJtJREFUGBljvHHjRjIjI2M9AwNDurq6+nYgjRPcvHnTEyg58////41MQE2cQIYsUGA9VAKrRqjcepBakB4moC1TgConAQXYcWlG0gRSMwmkhxFmPNDJE4HsPKBpP4F0IMzZ6Jo0NDTyQXrgGkEcdM0gMSAAOQ9sE0wTSBBFI0gATTMDNk1YNSJrBrGBYBKyTRAhPCTQbzkgjEsJAA6UVXk2tMUIAAAAAElFTkSuQmCC) no-repeat 192px 21px;
                }
                .menu-title1 {
                    color: #fff;
                    background: #4095ef url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAJCAYAAAACTR1pAAAAAXNSR0IArs4c6QAAAH1JREFUKBVjYMAB/v//HwDEKTiksQsDNeQBMQxMxK4KTRSoGqbpH5D9E6obv2Y0TelAvicQ/8CrGV0TzCF4NePShFczUBMo9EAA5Kd0mGJ0GiiH7OxiJqACPiD+AsQZjIyMM9E1wPhAue1AdiAQfwBiXrA40DRmMIMIAqYWAO7arIKv9HeGAAAAAElFTkSuQmCC) no-repeat 192px 21px;
                }
                .menu-sub {

                    background: rgba(64,149,239,.15);
                    ul{
                        li{

                                position: relative;
                                display: block;
                                height: 50px;
                                line-height: 50px;
                                padding-left: 63px;
                                font-size: 14px;
                                color: #000;

                        }
                    }
                }

            }
        }

    }
</style>
